import { render, staticRenderFns } from "./DialogLeaveIdea.vue?vue&type=template&id=1c72822e"
import script from "./DialogLeaveIdea.vue?vue&type=script&lang=js"
export * from "./DialogLeaveIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports